import { css } from '@emotion/core';

import { grid, SPACE_COMFORTABLE } from '@/styles';

export const root = css`
  /* NOTE: Why are we target data-testid? Refer to src/components/composed/slo-card/mini-styles.ts:38 */
  [data-testid='capability-dependency-list'] {
    max-width: fit-content;
  }
`;

export const main = [
  grid,
  css`
    grid-gap: ${SPACE_COMFORTABLE}px;
    grid-auto-flow: column;
  `,
];
